import React, { Component } from 'react'
import './style.scss';
import { Alert, Checkbox, Icon, Tabs, Input, Form, Button, Modal, Select ,message} from 'antd';
import md5 from 'js-md5';
import Request from "../../networkReq/request";
import Http from "../../networkReq/http"
import {
    setToken,
    setCurrentUser,
    setUserId,
    setCaptchaKey,
    debounce,
    setCitys,
    getDict,
    setDict,
    getMfaDeviceId
} from 'utils/storage';

const { Option } = Select;
const { TabPane } = Tabs;
const { TextArea } = Input
const FormItem = Form.Item;
const LOGIN_LOCK_LIMIT = 10;
const LOGIN_LOCK_MS = 10 * 60 * 1000;
let phoneReg =
  /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
export default class index extends Component {
    state = {
        visible: false,
        modalVisible: false,
        users: {
            tenant_id: '894699',
            username: '',
            password: '',
            verificationCode: '',
            grant_type: "captcha",
        },
        uid: '',
        remember: '',
        showCodeInput: true,
        lastRemember: false,
        submitting: false,
        mfaStep: false,
        mfaNeedBind: false,
        mfaMaskedPhone: '',
        mfaTempToken: '',
        mfaUsername: '',
        mfaUserType: '',
        countdown: 0,
        sendingSms: false
    };
    mfaFormRef = React.createRef();
    componentDidMount() {
        this.uuid()
    }
    componentWillUnmount() {
        if (this.smsTimer) {
            clearInterval(this.smsTimer);
        }
    }

    onChange(key, value) {
        // console.log('valuevalue', key, value);
        this.setState({
            form: Object.assign({}, this.state.form, { [key]: value })
        });
    }
    uuid(){
        Http.get(Request.getVerificationCode(), {}, obj => {
            // console.log('obj',obj)
            setCaptchaKey(obj.key)
            this.setState({ verificationCode: obj.image,});
        });
    }
    getLoginLockKey = username => {
        if (!username) {
            return '';
        }
        return `login_fail_${username}`;
    };
    getLoginLockInfo = username => {
        const key = this.getLoginLockKey(username);
        if (!key) {
            return null;
        }
        try {
            const raw = localStorage.getItem(key);
            return raw ? JSON.parse(raw) : null;
        } catch (err) {
            return null;
        }
    };
    setLoginLockInfo = (username, info) => {
        const key = this.getLoginLockKey(username);
        if (!key) {
            return;
        }
        if (!info) {
            localStorage.removeItem(key);
            return;
        }
        localStorage.setItem(key, JSON.stringify(info));
    };
    clearLoginLockInfo = username => {
        this.setLoginLockInfo(username, null);
    };
    isLoginLocked = username => {
        const info = this.getLoginLockInfo(username);
        if (!info || !info.lockedUntil) {
            return false;
        }
        const now = Date.now();
        if (info.lockedUntil <= now) {
            this.clearLoginLockInfo(username);
            return false;
        }
        const remainMinutes = Math.ceil((info.lockedUntil - now) / 60000);
        message.error(`登录失败次数过多，请${remainMinutes}分钟后再试`);
        return true;
    };
    recordLoginFailure = username => {
        if (!username) {
            return;
        }
        const info = this.getLoginLockInfo(username) || { count: 0, lockedUntil: 0 };
        const nextCount = info.count + 1;
        const nextInfo = { count: nextCount, lockedUntil: info.lockedUntil };
        if (nextCount >= LOGIN_LOCK_LIMIT) {
            nextInfo.lockedUntil = Date.now() + LOGIN_LOCK_MS;
        }
        this.setLoginLockInfo(username, nextInfo);
        if (nextCount >= LOGIN_LOCK_LIMIT) {
            message.error('登录失败次数过多，请10分钟后再试');
        }
    };
   
    handleSubmit = e => {
        const { remember, lastRemember } = this.state;
        this.setState({loading:true})
         e.password= e.password.trim()
         e.username= e.username.trim()
         if (this.isLoginLocked(e.username)) {
            this.setState({ loading: false });
            return;
         }
          let params = {
            ...e,
            tenant_id: 894699,   
            // Authorization:'Basic c3dvcmQ6c3dvcmRfc2VjcmV0 ',   
            scope: 'all',
            grant_type: 'captcha',
          };
          if (params.password.length < 20) {
            params.password = md5(params.password);
          }
          params.remember = remember;
          if (lastRemember) {
            params.verificationCode = 'ssss';
          }
          Http.postLogin(Request.getLogin(), params, obj => {
            console.log(obj);
            if (obj && (obj.mfa_required === 'true' || obj.mfa_required === true || obj.error === 'mfa_required')) {
                this.setState({
                    loading: false,
                    mfaStep: true,
                    mfaNeedBind: obj.need_bind_phone === 'true' || obj.need_bind_phone === true,
                    mfaMaskedPhone: obj.masked_phone || '',
                    mfaTempToken: obj.temp_token,
                    mfaUsername: params.username,
                    mfaUserType: params.userType
                });
                return;
            }
            if (obj.error) {
                message.error(obj.error_description);
                this.recordLoginFailure(e.username);
                if (obj.error_description == '验证码输入错误') {
                
                }
                this.setState({
                    loading: false
                })
                this.uuid();
            } else {
                if (obj.access_token) {
                    this.loginSuccess(obj, e.username);
                } else {
                    this.setState({ loading: false });
                }
            }})
        //   dispatch({
        //     type: 'login/login',
        //     payload: params,
        //     callback: (payload,response) => {
        //       this.sucess(payload,response);
        //     },
        //   }).then(
        //     this.uuid(),
        //   );
        // });
      };
    loginSuccess = (obj, username) => {
        message.success('登录成功');
        setToken(obj.access_token);
        setCurrentUser(obj);
        setUserId(obj.user_id);
        this.clearLoginLockInfo(username);
        this.setState({
            loading: false,
            mfaStep: false
        });
        Http.get(Request.getCityList(), {}, (cityObj) => {
            if (cityObj.code == 200) {
                setCitys(cityObj.data);
            } else {
                message.error(`${cityObj.msg}`);
            }
        });
        Http.get(Request.getNewDict(), {}, (dictObj) => {
            if (dictObj.code == 200) {
                setDict(dictObj.data);
            } else {
                message.error(`${dictObj.msg}`);
            }
        });
        this.props.history.push('/entrance/home');
    };
    startSmsCountdown = () => {
        this.setState({ countdown: 60 });
        if (this.smsTimer) {
            clearInterval(this.smsTimer);
        }
        this.smsTimer = setInterval(() => {
            this.setState(prev => {
                if (prev.countdown <= 1) {
                    clearInterval(this.smsTimer);
                    return { countdown: 0 };
                }
                return { countdown: prev.countdown - 1 };
            });
        }, 1000);
    };
    handleSendMfaSms = () => {
        const { mfaNeedBind, mfaTempToken, countdown, sendingSms } = this.state;
        if (countdown > 0 || sendingSms) {
            return;
        }
        let phone = '';
        if (mfaNeedBind) {
            const values = this.mfaFormRef.current ? this.mfaFormRef.current.getFieldsValue() : {};
            phone = values.phone;
            if (!phoneReg.test(phone)) {
                message.error('请输入正确的11位手机号');
                return;
            }
        }
        this.setState({ sendingSms: true });
        Http.getMfaSms(Request.getMfaSms(), {
            temp_token: mfaTempToken,
            phone: phone || '',
            tenantId: 894699
        }, res => {
            this.setState({ sendingSms: false });
            const success = res && (res.success === true || res.code === 200 || res.code === '200');
            if (success) {
                message.success(res.msg || res.message || '验证码已发送');
                this.startSmsCountdown();
            } else {
                message.error((res && (res.msg || res.message || res.error_description)) || '验证码发送失败');
            }
        });
    };
    handleMfaSubmit = (e) => {
        const { mfaTempToken, mfaUsername, mfaUserType, mfaNeedBind, remember } = this.state;
        this.setState({ loading: true });
        const params = {
            username: mfaUsername,
            userType: mfaUserType,
            tenant_id: 894699,
            scope: 'all',
            grant_type: 'captcha',
            temp_token: mfaTempToken,
            code: e.code,
            device_id: getMfaDeviceId(),
            remember
        };
        if (mfaNeedBind) {
            params.phone = e.phone;
        }
        Http.postLogin(Request.getLogin(), params, obj => {
            if (!obj || obj === -1) {
                message.error('验证失败，请稍后重试');
                this.setState({ loading: false });
                return;
            }
            if (obj.mfa_required === 'true' || obj.mfa_required === true || obj.error === 'mfa_required') {
                message.error(obj.error_description || '请完成短信验证');
                this.setState({ loading: false });
                return;
            }
            if (obj.error) {
                message.error(obj.error_description || '验证失败');
                this.setState({ loading: false });
                return;
            }
            if (obj.access_token) {
                this.loginSuccess(obj, mfaUsername);
            } else {
                this.setState({ loading: false });
            }
        });
    };
    forgetPassword = () =>{
        this.setState({visible:true})
    }
    handleCancel = () =>{
        this.setState({visible:false})
    }
    handleSubmit2 = (e) => {
        // console.log('qwqweqweqweqw', e);
        if (this.isLoginLocked(e.username)) {
            this.setState({ loading: false });
            return;
        }
        Http.postLogin(Request.getLogin(), {...e,grant_type:'smscaptcha'}, obj => {
              
            if (obj.error) {
                message.error(obj.error_description);
                this.recordLoginFailure(e.username);
                if (obj.error_description == '验证码输入错误') {
                
                }
                this.setState({
                    loading: false
                })
                this.uuid();
            } else {
                if (obj.access_token) {
                    this.loginSuccess(obj, e.username);
                }
            }})
    }
    //记住密码
    rememberPassword = e => {
        // console.log('checked = ', e.target.checked);
        this.setState({
          remember: e.target.checked,
        });
       
      };
    //判断上次有没有勾选记住密码
    detection() {
        let account = localStorage.getItem('account');
        if (account != null) {
          let obj = JSON.parse(account);
    
          let users = {
            tenant_id: obj.tenant_id,
            username: obj.username,
            password: obj.password,
            verificationCode: 'ssss',
            grant_type: "captcha",
          };
    
          this.setState({
            users: users,
            showCodeInput: false,
            remember: true,
            lastRemember: true,
          });
        }
    
      }
    getHero = ()=>{
        // getverifyIdentity
        const { phone} = this.state
        // console.log('phonephone',phone);
        
        let  params = {
            phone:phone,
            tenantId:894699
        }
        Http.get(Request.getverifyIdentity(), params, obj => {
            // console.log('objobj',obj);
            if(obj.code==200){
                message.success('发送成功   ')
            }else{
                message.error(obj.msg ? obj.msg :'发送失败')
            }
            
        })
    }
    render() {
        const { users, visible, modalVisible, verificationCode, uid, showCodeInput, remember, submitting,loading, mfaStep, mfaNeedBind, mfaMaskedPhone, countdown, sendingSms } = this.state;

        return ( 
            <div className='wrapperBox'>
                <div className='webName' onClick={()=>this.props.history.push('/entrance/home')}>眉山市退役军人就业创业网</div>
                <div className='loginInfoBox'>
                    <div className='title'>
                        账号登录
                        </div>
                    <div>
                        <div className='center'>
                            {mfaStep ? (
                            <Form ref={this.mfaFormRef} onFinish={this.handleMfaSubmit}>
                                <div className='mfaTip'>
                                    {mfaNeedBind
                                        ? '首次登录需重新绑定手机号，绑定后将用于短信二次验证'
                                        : `请输入发送至 ${mfaMaskedPhone || '已绑定手机'} 的短信验证码`}
                                </div>
                                {mfaNeedBind ? (
                                    <FormItem
                                        name="phone"
                                        rules={[
                                            { required: true, message: '请输入手机号' },
                                            { pattern: phoneReg, message: '请输入正确的11位手机号' }
                                        ]}
                                    >
                                        <Input placeholder="请输入要绑定的手机号" maxLength={11} />
                                    </FormItem>
                                ) : null}
                                <FormItem>
                                    <div className='checkCode' style={{ overflow: 'hidden' }}>
                                        <FormItem
                                            name="code"
                                            noStyle
                                            rules={[{ required: true, message: '请输入短信验证码' }]}
                                        >
                                            <Input placeholder="请输入短信验证码" maxLength={6} style={{ width: '66%', float: 'left' }} />
                                        </FormItem>
                                        <Button
                                            type="primary"
                                            htmlType="button"
                                            style={{ float: 'right', height: '40px' }}
                                            disabled={countdown > 0 || sendingSms}
                                            loading={sendingSms}
                                            onClick={this.handleSendMfaSms}
                                        >
                                            {countdown > 0 ? `${countdown}s` : '获取验证码'}
                                        </Button>
                                    </div>
                                </FormItem>
                                <FormItem>
                                    <Button
                                        htmlType="submit"
                                        style={{ width: '100%', height: '40px', color: '#fff', fontSize: '16px', background: '#134AD4', borderColor: '#0740d3', borderRadius: '4px' }}
                                        loading={loading}
                                    >
                                        验证并登录
                                    </Button>
                                </FormItem>
                                <div style={{ textAlign: 'center', marginBottom: '10px' }}>
                                    <a onClick={() => this.setState({ mfaStep: false, mfaTempToken: '', mfaMaskedPhone: '' })}>
                                        返回账号登录
                                    </a>
                                </div>
                            </Form>
                            ) : (
                            <Form onFinish={debounce(this.handleSubmit)}>
                                {/* <FormItem
                                    // label="Username"
                                    name="tenant_id"
                                    rules={[{ required: true, message: '请输入租户ID', }]}
                                >
                                    <Input
                                        placeholder="请输入租户ID"
                                    />
                                </FormItem> */}
                                <FormItem
                                    // label="Username"
                                    name="username"
                                    rules={[{ required: true, message: '请输入用户名', initialValue: users.tenantId, }]}
                                >
                                    <Input
                                        placeholder="请输入用户名"
                                    />
                                </FormItem>
                                <FormItem
                                    name="password"
                                    rules={[{ required: true, message: '请输入密码', initialValue: users.password, }]}
                                >
                                    <Input
                                        // prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                        type="password"
                                        placeholder="请输入密码"
                                    />
                                </FormItem>
                                {
                                    showCodeInput ? <FormItem
                                        name="verificationCode"
                                        rules={[{ required: true, message: '请输入验证码', }]}
                                    >
                                        <div className='checkCode'>
                                            <div style={{ width: '66%', float: 'left' }}>

                                                <Input
                                                    // prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)', borderRight: 'none' }} />}
                                                    type="text"
                                                    placeholder="请输入验证码" onChange={this.onChange.bind(this, 'verificationCode')}
                                                />
                                            </div>
                                            <div style={{ borderRadius: '0 4px 4px 0', float: 'right', fontSize: '22px', fontWeight: 'bold', width: '30%', height: '40px', lineHeight: '40px', border: '1px solid #d9d9d9', color: '#0740d3', textAlign: 'center',display:'flex',justifyItems:'center',alignItems:'center', boxSizing: 'border-box' }}>
                                                <img style={{ height: '35px',margin:'0 auto' }} src={verificationCode} onClick={() => this.uuid()} />
                                            </div>
                                        </div>
                                    </FormItem>
                                        : null
                                }
                                <FormItem
                                    name="userType"
                                    rules={[{ required: true, message: '请选择用户类型' }]}
                                >
                                    <Select
                                        className='EndSelect'
                                        placeholder="请选择用户类型"
                                    >
                                        <Option value='2'>退役军人</Option>
                                        <Option value='5'>招聘企业用户</Option>
                                        <Option value='6'>培训机构用户</Option>
                                        <Option value='7'>金融机构用户</Option>
                                    </Select>
                                    
                                </FormItem>
                                <FormItem>
                                    <Button
                                        htmlType="submit"
                                        style={{ width: '100%', height: '40px', color: '#fff', fontSize: '16px', background: '#134AD4', borderColor: '#0740d3', borderRadius: '4px' }}
                                        loading={loading}
                                    >
                                        登录
                        </Button>
                                </FormItem>
                                <div style={{ width: '100%', height: '20px' }}>
                                    <Checkbox onChange={this.rememberPassword} style={{ float: 'left' }} checked={remember}>记住密码</Checkbox>
                                    <a style={{ float: 'right', color: '#1890ff' }} onClick={() => this.forgetPassword()}>
                                        忘记密码？
                            </a>
                                </div>
                                <div className='notice'>
                                    推荐使用谷歌浏览器、IE11浏览器、360安全浏览器请切换至极速模式
                        </div>
                            </Form>
                            )}
                        </div>
                    </div>

                    <Modal
                        title="忘记密码"
                        visible={visible}
                        className='closeModal'
                        centered={true}
                        onCancel={this.handleCancel}
                        width={400}
                        footer={[]}
                        destroyOnClose
                    >
                          <Form onFinish={this.handleSubmit2}>
                                <FormItem
                                    name="userType"
                                    rules={[{ required: true, message: '请选择用户类型' }]}
                                >
                                    <Select
                                        className='EndSelect'
                                        placeholder="请选择用户类型"
                                    >
                                         <Option value='2'>退役军人</Option>
                                        <Option value='5'>招聘企业用户</Option>
                                        <Option value='6'>培训机构用户</Option>
                                        <Option value='7'>金融机构用户</Option>
                                    </Select>
                                </FormItem>
                                <FormItem
                                    name="username"
                                    rules={[
                                        {
                                          required: true,
                                          validator: (rule, value, callback) => {
                                            if (value && !phoneReg.test(value)) {
                                              callback("请输入正确的手机号码");
                                            } else {
                                              callback();
                                            }
                                          },
                                        },
                                      ]}
                                >
                                    <Input
                                        // prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                        type="number"
                                        placeholder="请输入手机号码"
                                        onChange={(value)=>this.setState({phone:value.target.value})}
                                    />
                                </FormItem>
                                <FormItem
                                        name="code"
                                        rules={[{ required: true, message: '请输入验证码', }]}
                                    >
                                        <div className='checkCode'>
                                            <div style={{ width: '66%', float: 'left' }}>

                                                <Input
                                                    // prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)', borderRight: 'none' }} />}
                                                    type="text"
                                                    placeholder="请输入验证码" onChange={this.onChange.bind(this, 'verificationCode')}
                                                />
                                            </div>
                                            {/* <div style={{ borderRadius: '0 4px 4px 0', float: 'right', fontSize: '22px', fontWeight: 'bold', width: '30%', height: '40px', lineHeight: '40px', border: '1px solid #d9d9d9', color: '#0740d3', textAlign: 'center', boxSizing: 'border-box' }}> */}
                                                <Button type="primary" style={{float: 'right',}} onClick={this.getHero}>获取验证码</Button>
                                            {/* </div> */}
                                        </div>
                                    </FormItem>
                                <FormItem>
                                    <Button
                                        htmlType="submit"
                                        style={{ width: '100%', height: '40px', color: '#fff', fontSize: '16px', background: '#134AD4', borderColor: '#0740d3', borderRadius: '4px' }}
                                        loading={submitting}
                                    >
                                        确认
                                    </Button>
                                </FormItem>
                            </Form>
                    </Modal>

                </div>
            </div>
        );
    }
}
















